import {
	LEGAL_NAVIGATION,
	NAVIGATION,
	SUB_NAVIGATION_FOOTER,
} from '@utils/constants';
import cx from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import * as styles from './Footer.module.css';

import ScrollToTop from '@components/Molecule/ScrollToTop/ScrollToTop';
import LinkedIn from '@components/SVG/LinkedIn';
import Logo from '@components/SVG/Logo';
import YouTube from '@components/SVG/YouTube';
import Copy from '@components/Typography/Copy';

const Footer = (): JSX.Element => {
	return (
		<footer id="footer" role="contentinfo" className={styles.footer}>
			<div className={cx(styles.layout, 'container')}>
				<ScrollToTop />

				<div className={styles.index}>
					<h4>How we can help you</h4>

					<nav className={styles.navigation} aria-label="Footer menu">
						<ul className={styles.list}>
							{NAVIGATION.map(({ label, to, icon }, key) => (
								<li key={key}>
									<Link to={to}>{label}</Link>
								</li>
							))}
						</ul>
						<ul className={styles.list}>
							{SUB_NAVIGATION_FOOTER.map(({ label, to }, key) => (
								<li key={key}>
									<Link to={to}>{label}</Link>
								</li>
							))}
						</ul>
					</nav>
				</div>

				<div className={styles.social}>
					<h4>Social</h4>
					<div className={styles.links}>
						<a
							href="https://www.linkedin.com/company/uhv-design-ltd"
							target="_blank"
							rel="nofollow noopener"
							className={styles.platform}>
							<LinkedIn className={styles.icon} />
							LinkedIn
						</a>

						<a
							href="https://www.youtube.com/user/UHVDesign"
							target="_blank"
							rel="nofollow noopener"
							className={styles.platform}>
							<YouTube className={styles.icon} />
							YouTube
						</a>
					</div>
				</div>

				<div className={styles.contact}>
					<h4>Contact UHVD</h4>

					<address>
						Acorn House, The Broyle, Ringmer, East Sussex, England, BN8 5NN
					</address>

					<div>
						<Copy font="xs">
							Telephone:{' '}
							<a href="tel:+44 (0)1323 811188">
								+44 (0)1323 811188
							</a>
						</Copy>

						<Copy font="xs">
							Email:{' '}
							<a href="mailto:sales@uhvdesign.com">
								sales@uhvdesign.com
							</a>
						</Copy>
					</div>
				</div>
			</div>

			<div className={cx(styles.socket, 'container')}>
				<div className={styles.copyright}>
					<Copy font="xs">
						© {new Date().getFullYear()} UHV Design
					</Copy>

					<Copy font="xs">
						Designed and developed by{' '}
						<a href="https://majordigital.com/">Major Digital</a>.
					</Copy>
				</div>

				<nav className={cx(styles.navigation, styles.socketNavigation)}>
					<ul className={cx(styles.list, styles.socketList)}>
						{LEGAL_NAVIGATION.map(({ label, to }, key) => (
							<li key={key}>
								<Link to={to}>{label}</Link>
							</li>
						))}
					</ul>
				</nav>

				<Logo className={styles.logo} />
			</div>
		</footer>
	);
};

export default Footer;
